module.exports = __webpack_public_path__ + "img/photos.9501f46b.webp";